var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('RelativeAnchor',{attrs:{"id":_vm.data.pageTitle,"block-id":_vm.data.id}}),_vm._v(" "),_c('ProductOverviewGallery',{attrs:{"parent-slide-index":_vm.currentSlide,"data":_vm.data},on:{"orientation-changed":_vm.getPersistedSlideIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }